var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("div", { staticClass: "modal-close-btn-point" }, [
        _c(
          "div",
          {
            staticClass: "modal-close-btn-container",
            on: {
              click: function($event) {
                return _vm.$emit("close")
              }
            }
          },
          [_c("SVGModalClose")],
          1
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "ap-modal-title-big" }, [
        _vm._v("\n        Добавить заказчика\n    ")
      ]),
      _vm._v(" "),
      _c("DataEntryForCustomers", {
        attrs: { buttonName: "Добавить" },
        on: { apply: _vm.apply }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }